<h2 mat-dialog-title class="dialog-title">
  Devis — {{ data.devisReference ?? data.devisId }}
  <span class="badge-statut" [ngClass]="getStatutBadgeClass()">{{ data.devisStatut }}</span>
</h2>

<mat-dialog-content class="dialog-content">

  <!-- Section FEB (lecture seule) -->
  <mat-expansion-panel [expanded]="true" class="feb-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>Informations de la Fiche Expression de Besoin</mat-panel-title>
    </mat-expansion-panel-header>

    <div class="info-grid">
      <div class="info-row" *ngIf="data.febLabel">
        <span class="info-label">Libellé FEB</span>
        <span class="info-value">{{ data.febLabel }}</span>
      </div>
      <div class="info-row" *ngIf="data.febProjectNom">
        <span class="info-label">Projet</span>
        <span class="info-value">{{ data.febProjectNom }}</span>
      </div>
      <div class="info-row" *ngIf="data.febEntiteSncfNom">
        <span class="info-label">Entité SNCF</span>
        <span class="info-value">{{ data.febEntiteSncfNom }}</span>
      </div>
      <div class="info-row" *ngIf="data.febDivisionDemandeurNom">
        <span class="info-label">Division demandeur</span>
        <span class="info-value">{{ data.febDivisionDemandeurNom }}</span>
      </div>
      <div class="info-row" *ngIf="data.febDateDemande">
        <span class="info-label">Date de demande</span>
        <span class="info-value">{{ data.febDateDemande | date: 'dd/MM/yyyy' }}</span>
      </div>
      <div class="info-row" *ngIf="data.febLocalisationLabel">
        <span class="info-label">Localisation</span>
        <span class="info-value">{{ data.febLocalisationLabel }}</span>
      </div>
      <div class="info-row" *ngIf="data.febUoActivitePressentiLabel">
        <span class="info-label">Activité UO pressentie</span>
        <span class="info-value">{{ data.febUoActivitePressentiLabel }}</span>
      </div>
      <div class="info-row" *ngIf="data.febNomenclature">
        <span class="info-label">Nomenclature</span>
        <span class="info-value">{{ data.febNomenclature }}</span>
      </div>
      <div class="info-row" *ngIf="data.febPcSncf !== null && data.febPcSncf !== undefined">
        <span class="info-label">PC SNCF</span>
        <span class="info-value">{{ data.febPcSncf ? 'Oui' : 'Non' }}</span>
      </div>
      <div class="info-row" *ngIf="data.febPresenceSiteSncf">
        <span class="info-label">Présence site SNCF</span>
        <span class="info-value">{{ data.febPresenceSiteSncf }}</span>
      </div>
      <div class="info-row full-width" *ngIf="data.febContexteObjectifProjet">
        <span class="info-label">Contexte / Objectif</span>
        <span class="info-value">{{ data.febContexteObjectifProjet }}</span>
      </div>
    </div>

    <!-- Activités FEB -->
    <div *ngIf="data.febActivites && data.febActivites.length > 0" class="activites-section">
      <h4 class="section-subtitle">Activités</h4>
      <div class="activites-list">
        <div *ngFor="let act of data.febActivites" class="activite-row">
          <span class="activite-label">{{ act.label }}</span>
          <span class="activite-pct">{{ act.pourcentage }}%</span>
        </div>
      </div>
    </div>
  </mat-expansion-panel>

  <!-- Section Chiffrage CDC (éditable) -->
  <div class="section-header">Chiffrage CDC</div>
  <form [formGroup]="devisForm" class="chiffrage-form">

    <div class="chiffrage-row">
      <div class="chiffrage-col">
        <div class="readonly-field">
          <span class="readonly-label">Prix UO Grille (€)</span>
          <span class="readonly-value">
            {{ prixUoGrilleDisplay != null ? (prixUoGrilleDisplay | number:'1.2-2') : '—' }}
          </span>
        </div>
      </div>
      <div class="chiffrage-col">
        <div class="readonly-field">
          <span class="readonly-label">Montant Total (€)</span>
          <span class="readonly-value">
            {{ montantTotalCalcule != null ? (montantTotalCalcule | number:'1.2-2') : '—' }}
          </span>
        </div>
      </div>
    </div>

    <div class="toggle-row">
      <mat-slide-toggle formControlName="devisMajore" color="primary">
        Prix majoré
      </mat-slide-toggle>
    </div>

    <div class="chiffrage-row">
      <div class="chiffrage-col">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Date de démarrage</mat-label>
          <input matInput [matDatepicker]="pickerDemarrage" formControlName="devisDateDemarrageGo" readonly>
          <mat-datepicker-toggle matSuffix [for]="pickerDemarrage"></mat-datepicker-toggle>
          <mat-datepicker #pickerDemarrage></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="chiffrage-col">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Durée prévisionnelle (jours)</mat-label>
          <input matInput type="number" formControlName="devisDuree" min="0">
        </mat-form-field>
      </div>
    </div>

    <!-- ── Date d'entretien — OBLIGATOIRE ─────────────────────────── -->
    <div class="chiffrage-row">
      <div class="chiffrage-col">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>
            Date d'entretien <span class="required-star">*</span>
          </mat-label>
          <input matInput
                 [matDatepicker]="pickerEntretien"
                 formControlName="devisDateEntretien"
                 readonly>
          <mat-datepicker-toggle matSuffix [for]="pickerEntretien"></mat-datepicker-toggle>
          <mat-datepicker #pickerEntretien></mat-datepicker>
          <mat-error *ngIf="devisForm.get('devisDateEntretien')?.hasError('required')">
            La date d'entretien est obligatoire
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="chiffrage-row">
      <div class="chiffrage-col">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Provision frais (€)</mat-label>
          <input matInput type="number" formControlName="devisProvisionFrais" min="0">
        </mat-form-field>
      </div>
      <div class="chiffrage-col">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Prix UO Proposé (€)</mat-label>
          <input matInput type="number" formControlName="devisPrixUoPropose" min="0" step="0.01">
        </mat-form-field>
      </div>
      <div class="chiffrage-col">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Bénéficiaire</mat-label>
          <input matInput formControlName="devisBeneficiaire">
        </mat-form-field>
      </div>
    </div>

    <div class="chiffrage-row">
      <div class="chiffrage-col">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Numéro de contrat</mat-label>
          <input matInput formControlName="devisNumeroContrat" readonly>
        </mat-form-field>
      </div>
      <div class="chiffrage-col">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Nom du contrat</mat-label>
          <input matInput formControlName="devisNomContrat" readonly>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Commentaire</mat-label>
      <textarea matInput formControlName="devisCommentaire" rows="3"></textarea>
    </mat-form-field>

  </form>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Fermer</button>
  <button mat-raised-button color="primary" *ngIf="canEdit()" (click)="onSave()" [disabled]="devisForm.pristine || !hasChanges()">
    Enregistrer
  </button>
</mat-dialog-actions>